import React, {Component} from 'react';
import {Dropdown, Icon, Popup} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";
import TipsModal from "./tipsModal";
import {
    CLAIMS_ROUTE,
    CONDITIONS_ROUTE,
    COVERAGE_DECLINED_PATH,
    ELIGIBILITY_LOSS,
    EXPIRED_ROUTE,
    FORGOT_PASSWORD,
    isAssociationContract,
    LEARN_ABOUT_COVERAGE_ROUTE,
    LINK_EXPIRED_ROUTE,
    NO_CONTRACT_TO_ENROL,
    NOT_IN_OPEN_ENROLLMENT_ROUTE,
    PASSWORD_RESET_REQUEST_SENT,
    REQUEST_SENT_ROUTE,
    RESET_PASSWORD,
    savePoints,
    SUCCESS_ROUTE,
    uiFlowBenAdmin,
    VERIFY_ITS_YOU_ROUTE
} from "../utils/common";
import CoveredModal from "./coveredModal";
import GetHelpModal from "./getHelpModal";
import {setUserInfo} from "../actions/userActions";
import {BrandedLogo, SupportEmailLink} from "./base";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import anselConfig from "../constants/anselConfig";
import {ClickableText, CustomGrid} from "./custom-common";
import {BenefitLimitsRequest} from "../services/types";
import {benefitLimitsService} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {appHeader, user, initialData} = state;
    const {uiFlow, contractInfo} = initialData;
    return {
        prevRoute: appHeader.prevRoute,
        lang: user.lang,
        lastVisitedSavePoint: user.lastVisitedSavePoint,
        initialData: initialData,
        statePostalCode: contractInfo.issueState,
        isBenAdmin: uiFlow === uiFlowBenAdmin,
        ...ownProps
    }
};

class AppHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayTipsModal: false,
            displayCoveredModal: false,
            forceTipsPopUpOpen: false,
            displayGetHelpModal: false,
            tipsPopUpOpen: false,
            benefitLimits: {},
        }
    }

    async componentDidMount() {
        const {isBenAdmin} = this.props;
        if (!isBenAdmin) {
            window.onbeforeunload = function (event) {
                event.preventDefault();
                event.returnValue = '';
            };
        } else {
            window.onbeforeunload = null;
        }
        await this.getBenefitLimits();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        const {prevRoute, lastVisitedSavePoint} = this.props;
        let route = window.location.pathname;
        const hideBackBtn = !route || route === "/" || route === "" || route.endsWith(SUCCESS_ROUTE);
        if (!hideBackBtn && !prevRoute && route !== "/enrollment/") {
            this.props.history.replace("/");
        }

        if (prevProps.lang !== this.props.lang) {
            await this.getBenefitLimits();
        }

        if (prevProps.location.pathname !== this.props.location.pathname) {
            const routeHasPopUp = route.endsWith(LEARN_ABOUT_COVERAGE_ROUTE) || route.endsWith(CONDITIONS_ROUTE) || route.endsWith(CLAIMS_ROUTE);
            if (!this.state.forceTipsPopUpOpen && routeHasPopUp) {
                this.setState({forceTipsPopUpOpen: true})
            }

            const {step} = lastVisitedSavePoint;
            if (route.startsWith("/enrollment/")) {
                route = route.split("/enrollment")[1];
            }
            if (route === "") {
                route = "/";
            }
            if (!!savePoints[route] && savePoints[route].step > step) {
                const savePoint = savePoints[route];
                this.props.dispatch(setUserInfo("SET_LAST_VISITED_SAVEPOINT_ROUTE", {route, step: savePoint.step}))
            }
        }
    }

     getBenefitLimits = async () => {
        const { lang, initialData, statePostalCode } = this.props;
        try{
            const request = new BenefitLimitsRequest({
                statePostalCode,
                languageCode: lang,
                contractTerms: initialData.ratedClass.contractTerms,
            });
            const data = await benefitLimitsService(request);
            if (data) {
                this.setState({benefitLimits: data});
            }
        }
        catch (error) {
            console.error("Error fetching benefit limits:", error);
        }
    }

    getRouteTipPopUpDescr = (strings) => {
        const route = window.location.pathname;
        if (route.endsWith(LEARN_ABOUT_COVERAGE_ROUTE)) {
            return strings.niceToMeetYou;
        }
        if (route.endsWith(CONDITIONS_ROUTE)) {
            return strings.conditionDetailsPage;
        }
        if (route.endsWith(CLAIMS_ROUTE)) {
            return strings.claims;
        }

        return null;
    }

    doDisplayCoveredModal = (status) => {
        let {displayTipsModal} = this.state;
        if (status) {
            displayTipsModal = false;
        }
        this.setState({
            displayTipsModal,
            displayCoveredModal: status,
        });
    }

    goTo = () => {
        window.location.href = STRATEGIC_PARTNER.CONTACT_SUPPORT.WEB_SITE;
    }

    render() {
        const {prevRoute, lang, initialData, isBenAdmin} = this.props;
        const {displayTipsModal, displayCoveredModal, displayGetHelpModal, forceTipsPopUpOpen, tipsPopUpOpen, benefitLimits} = this.state;
        const localization = getLocalization(lang);
        const strings = localization.tips;
        const appHeaderStrings = localization.appHeader;
        const getHelpStrings = localization.getHelp;
        const p = window.location.pathname;
        const notEligible = p.endsWith(ELIGIBILITY_LOSS);
        const unsubscribe = p.endsWith("unsubscribeSuccess") || p.endsWith("unsubscribe");
        const expired = p.endsWith(EXPIRED_ROUTE);
        const requestSent = p.endsWith(REQUEST_SENT_ROUTE);
        const success = p.endsWith(SUCCESS_ROUTE)
        const notOpenEnrollment = p.endsWith(NOT_IN_OPEN_ENROLLMENT_ROUTE);
        const learnAbout = p.endsWith(LEARN_ABOUT_COVERAGE_ROUTE)
        const verifyItsYou = p.endsWith(VERIFY_ITS_YOU_ROUTE)
        const forgotPassword = p.endsWith(FORGOT_PASSWORD)
        const passwordResetRequestSent = p.endsWith(PASSWORD_RESET_REQUEST_SENT)
        const resetPassword = p.endsWith(RESET_PASSWORD)
        const notContractToEnrol = p.endsWith(NO_CONTRACT_TO_ENROL);
        const coverageDeclined = p.endsWith(COVERAGE_DECLINED_PATH)
        const linkExpired = p.endsWith(LINK_EXPIRED_ROUTE);
        const isResetPasswordFlow = forgotPassword || passwordResetRequestSent || resetPassword;
        const hideBackBtn = !p || notEligible || unsubscribe || expired || coverageDeclined || linkExpired || p === "/" || p === "" || success || requestSent || learnAbout || verifyItsYou || p === "/enrollment" || p === "/enrollment/" || p === p.endsWith("/createAccount") || notOpenEnrollment || notContractToEnrol || passwordResetRequestSent || resetPassword;
        const hideTitle = unsubscribe || notOpenEnrollment;
        const hideActionItems = unsubscribe;
        const hideSendUsAmessage = !p || p === "/" || p === "" || p === "/enrollment" || p === "/enrollment/" || verifyItsYou || isBenAdmin || notOpenEnrollment || expired || requestSent || notEligible || linkExpired;
        const tipsPopUpText = this.getRouteTipPopUpDescr(strings);
        const hideTips = notOpenEnrollment || success || isResetPasswordFlow || !p || p === "/" || p === "" || p === "/enrollment" || p === "/enrollment/" || verifyItsYou || expired || requestSent || notEligible || coverageDeclined || linkExpired;
        const isAssociation = isAssociationContract(initialData.contractType);
        const conciergeBannerText = (!!initialData.notSaveUserProgress)
            ? "PREVIEW LINK, PROGRESS NOT SAVED"
            : `YOU'RE MAKING ELECTIONS ON THE ${isAssociation ? 'MEMBER' : 'EMPLOYEE'} BEHALF`;
        const onModalClose = () => this.setState({displayTipsModal: false});

        return (
            <div className='headerContainer nonprintable'
                 style={{position: 'sticky', top: 0, zIndex: 999}}>
                <TipsModal strings={strings}
                           benefitLimits={benefitLimits}
                           displayTipsModal={displayTipsModal}
                           onModalClose={onModalClose}
                           contractTerms={initialData.ratedClass.contractTerms}
                           onDisplayCoveredModalClick={() => this.doDisplayCoveredModal(true)}
                />
                <CoveredModal localization={localization}
                              benefitLimitsData={benefitLimits}
                              displayCoveredModal={displayCoveredModal}
                              onModalClose={() => this.doDisplayCoveredModal(false)}
                />
                <GetHelpModal localization={localization} uiFlow={initialData.uiFlow}
                              employerId={!!initialData && !!initialData.employer && initialData.employer.id}
                              displayCoveredModal={displayGetHelpModal}
                              onModalClose={() => this.setState({displayGetHelpModal: false})}
                />
                <CustomGrid>
                    {!!initialData.isConcierge && 
                        <div className={'conciergeBanner'}>
                            {conciergeBannerText}
                        </div>
                    }
                    <CustomGrid.Row columns={3} className={STRATEGIC_PARTNER.NAME !== anselConfig.NAME && 'headerRow'}>
                        <CustomGrid.Column width={4} textAlign={'left'} style={{paddingLeft: '1.5em'}}>
                            {!hideBackBtn ? (
                                <div onClick={() => this.props.history.push(prevRoute)}>
                                    <Icon name='arrow left' className='goBackIcon'/>
                                </div>
                            ) : (
                                <div className={'logoContainer'}>
                                    <BrandedLogo onClick={() => {this.goTo()}}/>
                                </div>
                            )}
                        </CustomGrid.Column>
                        <CustomGrid.Column width={4} textAlign={'center'} className={STRATEGIC_PARTNER.NAME !== anselConfig.NAME && 'centeredColumn'}>
                            {!hideTitle && <b>{appHeaderStrings.join}</b>}
                        </CustomGrid.Column>
                        {!hideActionItems &&
                        <CustomGrid.Column width={4} textAlign={'right'} className={STRATEGIC_PARTNER.NAME !== anselConfig.NAME && 'centeredColumn'}>
                            <CustomGrid.Row>
                                <span style={{...!hideTips && {marginRight: '39px'}}}>
                                    <Dropdown className="menuUserDropdown" text={appHeaderStrings.getHelp}
                                              onClick={() => this.setState({forceTipsPopUpOpen: false})}>
                                        <Dropdown.Menu style={{right: 0, left: 'auto', fontWeight: 'normal'}}>
                                            {!hideSendUsAmessage && <>
                                                <Dropdown.Item
                                                    style={{ marginTop: '0.5em' }}
                                                    className={STRATEGIC_PARTNER.NAME !== anselConfig.NAME && "small"}
                                                    text={STRATEGIC_PARTNER.NAME === anselConfig.NAME ? getHelpStrings.title : getHelpStrings.sendUsAmessage}
                                                    onClick={() => this.setState({ displayGetHelpModal: true })} />
                                                <Dropdown.Divider />
                                            </>}
                                            <div style={{margin: '1em', fontWeight: 'normal'}}>
                                                <p className={"small"} style={{marginBottom: '.5em'}}>
                                                    {getHelpStrings.emailUs} <SupportEmailLink />
                                                </p>
                                                <p className={"smaller neutral700Text"}>
                                                    {getHelpStrings.doNotIncludeSensitiveInformation}
                                                </p>
                                            </div>
                                            <Dropdown.Divider/>
                                            <div style={{margin: '1em', fontWeight: 'normal'}}>
                                                <p className='small'>{appHeaderStrings.callUsAt}<b> {STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}</b></p>
                                                {STRATEGIC_PARTNER.NAME === anselConfig.NAME && 
                                                    <p>
                                                        <small>{appHeaderStrings.monFri} 8am-8pm {getHelpStrings.tz}</small>
                                                    </p>
                                                }
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </span>
                                {!hideTips && <span onMouseEnter={() => this.setState({tipsPopUpOpen: true})}
                                                    onMouseLeave={() => this.setState({tipsPopUpOpen: false})}
                                                    onClick={() => this.setState({
                                                        forceTipsPopUpOpen: false,
                                                        tipsPopUpOpen: false,
                                                        displayTipsModal: true
                                                    })}>
                                    <Popup content={tipsPopUpText} position={'top right'}
                                           disabled={tipsPopUpText === null}
                                           className={'tipsPopUp'}
                                           open={forceTipsPopUpOpen || tipsPopUpOpen}
                                           on={'hover'}
                                           style={{cursor: 'pointer'}}
                                           trigger={
                                                <span>
                                                    <ClickableText onClick={() => {
                                                        this.setState({
                                                            forceTipsPopUpOpen: false,
                                                            displayTipsModal: true
                                                        });
                                                    }}>
                                                        <Icon.Group>
                                                            <Icon name='circle outline'
                                                                  style={{fontSize: '1.3em', margin: '-2px 2px 0 0'}}/>
                                                            <Icon name='info'
                                                                  style={{fontSize: '0.6em', margin: '-2px 3px 0 -1px'}}/>
                                                        </Icon.Group>

                                                        <span style={{marginLeft: '0.4em', marginRight: '1.7em'}}>
                                                            <b>{appHeaderStrings.tips}</b>
                                                        </span>
                                                   </ClickableText>
                                                </span>
                                           }
                                    />
                                </span>}
                            </CustomGrid.Row>
                        </CustomGrid.Column>
                        }
                    </CustomGrid.Row>
                </CustomGrid>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps)(AppHeader));
